<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <div>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <h6>Informe o código que foi enviado para seu e-mail: <br>
        <u>{{ this.$route.query.email }}</u>
        </h6>
        <br>
        <the-mask :mask="['# # # #']" v-model="codigo" class="codigo-verificacao"/>
        <br>
        <br>
        <div v-if="codigo.length == 4" class="btn waves-effect waves-light cor-primaria-bg" @click="ValidarCodigo()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Continuar
            </div>
          </div>
       </div>
       <div style="height: 400px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {SalvarLoginDoClienteNoNavegador} from "../../../services/auth";

export default {
  name: "ValidarCodigo",
  components: {
    LogoEmpresa,
    NavBarOnly,
    Loading
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      codigo:"",
      isLoading: false,
      fullPage: true
    };
  },
  methods: {
    ValidarCodigo()
    {
      this.isLoading = true;
      axios.post(this.$store.state.apiUrl + "cliente/autenticar", {
        email: this.$route.query.email,
        codigo_autenticacao_temporario: this.codigo
      }).then(response => {
        this.isLoading = false;
        SalvarLoginDoClienteNoNavegador(response.data.cliente);
        alert("Validação realizada com sucesso!");
        this.$router.push("/" + this.$store.state.empresa_url + "/cadastro-realizado-sucesso");
      }).catch(error => {
        this.isLoading = false;
        if(error.response){
          alert(error.response.data.message);
        }else{
          alert("Erro ao validar e-mail.");
        }
      });
    }
  }
};
</script>

<style scoped>
  @import '../../../assets/css/conteudo-splash.css';

  .codigo-verificacao{
      font-size: 30px !important;
      font-weight: 900 !important;
      left: 0 !important;
      right: 0 !important;
      width: 50% !important;
      background-color: white !important;
      text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/ValidarCodigo.vue